import React from "react";
import { Link, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { X, GitCompare } from "lucide-react";
import { useCompare } from "../context/CompareContext";
import { handleImgError } from "../lib/imgFallback";

export default function CompareBar() {
  const { items, remove, clear } = useCompare();
  const { pathname } = useLocation();
  if (items.length === 0 || pathname === "/compare") return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ y: 100, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: 100, opacity: 0 }}
        transition={{ ease: [0.16, 1, 0.3, 1], duration: 0.5 }}
        data-testid="compare-bar"
        className="fixed z-40 bg-[#171717] border border-white/10 glow-gold flex items-center gap-3 sm:gap-4 px-3 sm:px-4 py-2.5 sm:py-3 bottom-[calc(env(safe-area-inset-bottom)+72px)] lg:bottom-6 left-2 right-2 sm:left-1/2 sm:right-auto sm:-translate-x-1/2 sm:max-w-[92vw] sm:w-auto"
      >
        <div className="flex items-center gap-1.5 sm:gap-2 shrink min-w-0">
          {items.map((p) => (
            <div key={p.slug} className="relative w-9 h-9 sm:w-11 sm:h-11 bg-[#0F0F10] border border-white/10 shrink-0">
              <img src={p.image} alt={p.name} onError={handleImgError} className="h-full w-full object-cover" />
              <button data-testid={`compare-remove-${p.slug}`} onClick={() => remove(p.slug)} className="absolute -top-2 -right-2 bg-[#0F0F10] border border-white/20 rounded-full p-0.5"><X className="h-3 w-3 text-[#A8A8A8]" /></button>
            </div>
          ))}
        </div>
        <Link to="/compare" data-testid="compare-go-btn" className="btn-press bg-[#4ADE80] text-[#0F0F10] uppercase tracking-[0.12em] sm:tracking-[0.14em] text-[10px] sm:text-[11px] px-3 sm:px-5 py-2 sm:py-2.5 hover:bg-[#6FE998] inline-flex items-center gap-1.5 sm:gap-2 whitespace-nowrap shrink-0">
          <GitCompare className="h-3.5 w-3.5" /> <span className="hidden sm:inline">Compare </span>{items.length}
        </Link>
        <button data-testid="compare-clear-btn" onClick={clear} className="text-[10px] sm:text-[11px] uppercase tracking-[0.14em] text-[#7a7a7a] hover:text-[#F5F5F5] shrink-0">Clear</button>
      </motion.div>
    </AnimatePresence>
  );
}
